import { Box, Loader, TextNew } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, useEffect, useState } from 'react'
import { ResendLinkAlertBox } from '../../comps/ResendLinkAlertBox'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { AlertDialog } from '../ProfileMobile/LogoutAlert'
import { DetailsView } from './DetailsView'
import { Header } from './Header'

interface PaymentLinkDetailsProps {
  onDismiss: () => void
  id: any
  showStatusComponent?: (val?: boolean) => void
  refreshListingPage?: () => void
  showSuccessToastOfResendLink?: () => void
}

const PaymentLinkDetails: FC<PaymentLinkDetailsProps> = (props: PaymentLinkDetailsProps) => {
  const { onDismiss, id, showStatusComponent, refreshListingPage, showSuccessToastOfResendLink } = props
  const { paymentDetails, mid, fetchDetails, getMercLinkId, cancelPaymentLink, resendPaymentLink, setPaymentDetails } =
    useStores((store) => ({
      paymentDetails: store.links.getPaymentDetails,
      mid: store.user.selectedMid,
      fetchDetails: store.links.checkPaymentLinkStatus,
      getMercLinkId: store.links.getMerchantLinkIdFromJioLinkId,
      cancelPaymentLink: store.links.cancelPaymentLink,
      resendPaymentLink: store.links.resendPaymentLink,
      setPaymentDetails: store.links.setPaymentDetails,
    }))

  const [fetchDetailsData, fetchDetailsHandler] = useLazyApiData(fetchDetails)
  const [callCancelPaymentLink, cancelPaymentLinkHandler] = useLazyApiData(cancelPaymentLink)
  const [callResendPaymentLink, resendPaymentLinkHandler] = useLazyApiData(resendPaymentLink)
  const [isResenndModalVisible, setResendModalVisible] = useState(false)
  const [cancelModalVisible, setCancelModalVisible] = useState(false)
  const [mLinkId, setMLinkId] = useState('')
  const [isResendLoading, setResendLoading] = useState(false)
  const [refreshDetailPage, doRefreshOfDetail] = useState(0)

  const navigation = useNavigation()

  const detailsData = paymentDetails(id, { duplicate: false })
  // const detailsDataWithoutInvoice = paymentDetails(id, { duplicate: true })

  const onDuplicate = () => {
    setPaymentDetails(id)
    navigation?.navigate(Routes.CREATE_PAYMENT_LINK, { data: 'duplicate-payment-link' })
    onDismiss()
  }
  const onCancel = () => {
    setCancelModalVisible(true)
  }
  const onResend = () => {
    setResendModalVisible(true)
  }

  const sendLink = () => {
    if (mid && mLinkId && id) {
      setResendLoading(true)
      callResendPaymentLink(mid, mLinkId, id)
    }
  }

  const onCancelPress = () => {
    setResendModalVisible(false)
  }

  const onCancelConfirm = () => {
    if (mid && mLinkId && id) {
      callCancelPaymentLink(mid, mLinkId, id)
    }
  }

  useEffect(() => {
    const merchantLinkId = getMercLinkId(id)
    if (merchantLinkId && merchantLinkId !== '') {
      setMLinkId(merchantLinkId)
      fetchDetailsData(mid, merchantLinkId, id)
      doRefreshOfDetail((prev) => prev + 1)
    }
    //Removed MID dependency because it was re - triggering the API call whenever we changed the merchant from switch account.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDetailsData, getMercLinkId, id])

  useEffect(() => {
    if (cancelPaymentLinkHandler?.state === 'fulfilled') {
      showStatusComponent && showStatusComponent(false)
      setCancelModalVisible(false)
      onDismiss()
      refreshListingPage && refreshListingPage()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cancelPaymentLinkHandler.state === 'fulfilled'])

  useEffect(() => {
    if (resendPaymentLinkHandler?.state === 'fulfilled') {
      setResendLoading(false)
      onDismiss()
      setResendModalVisible(false)
      showSuccessToastOfResendLink && showSuccessToastOfResendLink()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resendPaymentLinkHandler?.state === 'fulfilled'])

  //TODO: check id for header
  return (
    <Box backgroundColor="WHITE" height="100vh">
      <Header
        plId={id}
        data={{ status: detailsData?.status, pushSmsTo: detailsData?.pushSmsTo, pushEmailTo: detailsData?.pushEmailTo }}
        onDismiss={onDismiss}
        onDuplicate={onDuplicate}
        onCancel={onCancel}
        onResend={onResend}
      />

      <Box paddingHorizontal={24} paddingVertical={32} justify="space-between" flexDirection="row">
        <TextNew type="titleBold16" color="BLACK_21" fontFamily={'jiotype-bold'}>
          Transaction Details
        </TextNew>
      </Box>
      {fetchDetailsHandler?.state === 'pending' && <Loader />}
      <DetailsView data={detailsData} refresh={refreshDetailPage} />
      <AlertDialog
        visible={cancelModalVisible}
        onCancelPress={() => onCancelConfirm()}
        onOkPress={() => setCancelModalVisible(false)}
        type={'CancelLink'}
        negativeLabel={'Yes, Cancel'}
        positiveLabel={"No, Don't"}
        title={'Cancel Link?'}
        subTitle={'The Link will be cancelled and the customer will not be able to pay via the link.'}
      />
      <ResendLinkAlertBox
        isVisible={isResenndModalVisible}
        onCancelPress={sendLink}
        mobile={detailsData?.pushSmsTo}
        email={detailsData?.pushEmailTo}
        onOkPress={onCancelPress}
        isLoading={isResendLoading}
      />
    </Box>
  )
}

export { PaymentLinkDetails }
